import banner from '../../../assets/industries/food.svg'

import tick from '../../../assets/industries/tick.webp'

import design from '../../../assets/industries/design.svg'
import website from '../../../assets/industries/website.svg'
import woo from '../../../assets/industries/woo.svg'
import custom from '../../../assets/industries/custom.svg'
import megneto from '../../../assets/industries/megneto.svg'
import shopify from '../../../assets/industries/shopify.svg'


export const bannerData = {
    title1: 'Grocery & Food Delivery App',
    title2: 'Development Services',
    desc: 'Serve customers at their doorsteps with on-demand grocery app and food delivery app development',
    img: banner,
    btnTitle: 'Hire Web & Mobile App Developers'
}

export const hireData = {
    img: tick,
    title: 'Outsource Food and Groceries',
    points: [
        'Transparent pricing',
        'UI/UX optimized development',
        'Streamlined communications and comprehensive reporting',
        'Data privacy protection',
        'Individual approach to every client',
        'Dedicated development teams',
        'Flexible engagement models',

    ]
}

export const webDesignData = {
    title1: 'Custom Food and',
    title1Span: 'Grocery App Development',
    title2: 'for Delightful Customer Experience',
    cards: [
        {
            title: 'Grocery App Development',
            desc: 'Expand your grocery business with Codezone’s Grocery app development services. Grocery app development solutions automate order management, delivery dispatch, real-time delivery tracking, and many such features. Scale your grocery business online today.',
            img: custom
        },
        {
            title: 'Food Delivery App Development',
            desc: 'Seamlessly connect foodies with restaurants nearby with custom food delivery apps. Codezone provides user-friendly food delivery app development solutions having advanced features for startups and businesses alike.',
            img: design
        },
        {
            title: 'Online Food Ordering App',
            desc: 'Grab on the exponential growth opportunity in the billion-dollar online food ordering industry with Codezone’s food ordering app development services. Get restaurant-consumer delivery, platform-consumer delivery, and many more apps and grow your business.',
            img: megneto
        },
        {
            title: 'Grocery Store Software',
            desc: 'Manage your sales and invoice your inventory with highly customize grocery store management and sales solutions. Codezone offers grocery store software and app development services for automating your daily operations.',
            img: woo
        },
    ]
}